export enum ErrorSeverity {
    INFO, WARNING, ERROR
}

export class BaseError extends Error {
    severity: ErrorSeverity
    #message: string
    reasons: Error[]
    type: string

    constructor(msg: string, severity?: ErrorSeverity, type?: string, reason?: Error) {
        super(msg);
        this.#message = msg
        if (severity) this.severity = severity
        else this.severity = ErrorSeverity.INFO
        this.reasons = []
        if (reason) this.reasons.push(reason)
        this.type = "UNKNOWN"
        if (type) this.type = type
    }
    get message(): string {
        return this.reasons.length > 0 ? this.reasons[0].message : ""
    }
    get erroneous(): boolean {
        return this.reasons.length > 0
    }
}

export class APIError extends BaseError {
    statusCode: number
    constructor(msg: string, severity?: ErrorSeverity, statusCode?:number, reason?: Error) {
        super(msg, severity, "API_ERROR", reason);
        this.statusCode = 0
        if (statusCode) this.statusCode = statusCode
    }
}